import { get } from 'lodash';
import { ActionTypes } from './constants';
import { AnalyticsTypes } from '../../middleware/google-analytics';
import { PROFILE_GA_CATEGORY } from '../constants';
import { EVENT_INITIATORS, INTERACTION_TYPES, TARGETS } from '../../EventTrackingConstants';
import { getProfilePageParameters } from '../state/selectors';

export const trackDisplayHeaderTitleTooltip = () => ({
    type: ActionTypes.TRACK_DISPLAY_HEADER_TITLE_TOOLTIP,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Provider Name Info Bubble',
            category: PROFILE_GA_CATEGORY,
            data: {
                Section: TARGETS.NAME_CARD,
                Component: TARGETS.I_BUBBLE,
                InteractionType: INTERACTION_TYPES.CLICK,
                Initiator: EVENT_INITIATORS.USER,
                Element: TARGETS.I_BUBBLE,
                EventAction: 'click name i bubble',
            },
        },
    },
});

export const trackClickIBubbleOfficeLocations = () => ({
    type: ActionTypes.TRACK_CLICK_I_BUBBLE_OFFICE_LOCATIONS,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click I Bubble Office Locations',
            category: PROFILE_GA_CATEGORY,
            data: {
                Section: TARGETS.PROFILE,
                Component: TARGETS.I_BUBBLE,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.I_BUBBLE,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'click office locations',
            },
        },
    },
});

export const trackNewExistingToggleView = () => {
    return (dispatch, getState) => {
        const state = getState();
        const initParams = get(getProfilePageParameters(state), 'initParameters') || {};
        const label = initParams.isNewPatient ? 'new' : 'existing';

        dispatch({
            type: ActionTypes.TRACK_NEW_EXISTING_TOGGLE_VIEW,
            meta: {
                analytics: {
                    type: AnalyticsTypes.TrackEvent,
                    action: 'New Existing Toggle View',
                    category: PROFILE_GA_CATEGORY,
                    label,
                    data: {
                        Section: TARGETS.PROFILE,
                        Component: TARGETS.NEW_EXISTING_PATIENT_TYPE_RADIO,
                        InteractionType: INTERACTION_TYPES.VIEW,
                        Element: TARGETS.NEW_EXISTING_PATIENT_TYPE_RADIO,
                        Initiator: EVENT_INITIATORS.USER,
                        EventAction: 'view new existing toggle',
                        EventDetails: {
                            InitialState: label,
                        },
                    },
                },
            },
        });
    };
};

export const trackReviewLinkClick = () => ({
    type: ActionTypes.CLICK_REVIEW_LINK,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Review Link',
            category: PROFILE_GA_CATEGORY,
            data: {
                Section: TARGETS.PROFILE,
                Component: TARGETS.PROFILE_HEADER_NAME_CARD,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.PROFILE_HEADER_REVIEW_LINK,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'ClickReviewLink',
            },
        },
    },
});

export const trackReviewStarsClick = rating => ({
    type: ActionTypes.CLICK_REVIEW_STARS,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Review Stars',
            category: PROFILE_GA_CATEGORY,
            data: {
                Section: TARGETS.PROFILE,
                Component: TARGETS.PROFILE_HEADER_NAME_CARD,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.PROFILE_HEADER_REVIEW_STARS,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'ClickReviewStars',
                EventDetails: {
                    AverageRatingShown: rating,
                },
            },
        },
    },
});

export const trackTabSelect = event => {
    const target = event.currentTarget;
    let title = 'NULL';
    if (target.dataset.tabControlIndex === '0') {
        title = 'Profile';
    } else if (target.dataset.tabControlIndex === '1') {
        title = 'Reviews';
    }

    return ({
        type: ActionTypes.CLICK_NAVIGATION_TABS,
        meta: {
            analytics: {
                type: AnalyticsTypes.TrackEvent,
                action: `Click ${title} Tab`,
                category: PROFILE_GA_CATEGORY,
                data: {
                    Section: TARGETS.PROFILE_NAVIGATION,
                    Component: TARGETS.PROFILE_NAVIGATION_TABS,
                    InteractionType: INTERACTION_TYPES.CLICK,
                    Element: `${title.replace(/ /g, '')}Tab`,
                    Initiator: EVENT_INITIATORS.USER,
                    EventAction: `click ${title.toLowerCase()} tab`,
                },
            },
        },
    });
};

export const trackClickServiceEmail = () => ({
    type: ActionTypes.CLICK_SERVICE_EMAIL,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Service Email',
            category: PROFILE_GA_CATEGORY,
            data: {
                Section: TARGETS.SERVICE_BANNER,
                Component: TARGETS.SERVICE_EMAIL,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.LINK,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'click service email',
            },
        },
    },
});

export const trackClickServicePhone = () => ({
    type: ActionTypes.CLICK_SERVICE_PHONE,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Service Phone',
            category: PROFILE_GA_CATEGORY,
            data: {
                Section: TARGETS.SERVICE_BANNER,
                Component: TARGETS.SERVICE_PHONE,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.LINK,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'click service phone',
            },
        },
    },
});

export const trackClickSeoBreadcrumb = url => ({
    type: ActionTypes.CLICK_SEO_BREADCRUMB,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Related Links Breadcrumb',
            category: PROFILE_GA_CATEGORY,
            data: {
                Section: TARGETS.RELATED_LINKS,
                Component: TARGETS.BREADCRUMB,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.LINK,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'click link',
                EventDetails: {
                    Link: url,
                },
            },
        },
    },
});

export const trackZocdocFooterLinkClicks = ({ action, Component, Element }) =>
    trackFooterLinkClicks({
        action,
        Section: TARGETS.ZOCDOC_FOOTER,
        Component,
        Element,
    });

export const trackLegalFooterLinkClicks = ({ action, Component, Element }) =>
    trackFooterLinkClicks({
        action,
        Section: TARGETS.LEGAL_FOOTER,
        Component,
        Element,
    });

const trackFooterLinkClicks = ({
    action, Section, Component, Element,
}) => ({
    type: ActionTypes.TRACK_PAGE_FOOTER_LINK_CLICK,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action,
            category: PROFILE_GA_CATEGORY,
            data: {
                Section,
                Component,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: action ? action.toLowerCase() : '',
            },
        },
    },
});

export const trackClickMobileHeaderShowMap = () => ({
    type: ActionTypes.TRACK_MOBILE_HEADER_VIEW_MAP,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Mobile Header View Map',
            data: {
                Component: TARGETS.MOBILE_HEADER_VIEW_MAP,
                Element: TARGETS.LINK,
                Initiator: EVENT_INITIATORS.USER,
                InteractionType: INTERACTION_TYPES.CLICK,
                Section: TARGETS.PAGE_HEADER,
                EventAction: 'click view map',
            },
        },
    },
});
